import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// =====================================================================
// Performance: load Google Fonts asynchronously (non render-blocking)
// =====================================================================
function injectAsyncFonts() {
  const head = document.head;
  // Preconnect to Google Fonts servers (saves DNS/TLS handshake time)
  const preconnects = [{
    href: 'https://fonts.googleapis.com',
    crossOrigin: ''
  }, {
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous'
  }];
  for (const p of preconnects) {
    if (head.querySelector(`link[rel="preconnect"][href="${p.href}"]`)) continue;
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = p.href;
    if (p.crossOrigin !== '') link.crossOrigin = p.crossOrigin;
    head.appendChild(link);
  }
  // Load the stylesheet via preload trick — non-blocking, async
  const fontsUrl = 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400..700;1,9..40,400..700&family=DM+Serif+Display:ital@0;1&display=swap';
  if (head.querySelector(`link[data-mp-fonts="1"]`)) return;
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'style';
  preload.href = fontsUrl;
  preload.setAttribute('data-mp-fonts', '1');
  preload.onload = function () {
    ;
    (this as HTMLLinkElement).onload = null;
    (this as HTMLLinkElement).rel = 'stylesheet';
  };
  head.appendChild(preload);
  // Fallback for browsers that don't support preload->style swap
  const noscript = document.createElement('noscript');
  const fallback = document.createElement('link');
  fallback.rel = 'stylesheet';
  fallback.href = fontsUrl;
  noscript.appendChild(fallback);
  head.appendChild(noscript);
}
injectAsyncFonts();
render(<App data-id="element-355" data-mp="27cr191lkqt2m" />, document.getElementById('root'));